export default "__VITE_ASSET__84100248__"